import { useSearchParams } from "react-router-dom";

export const usePaymentSearchParams = () => {
  const [searchParams] = useSearchParams();
  const dosage = searchParams.get("dosage") ?? undefined;
  const form = searchParams.get("form")?.toLowerCase();
  const priceId = searchParams.get("price") ?? undefined;
  const chosenPriceId = searchParams.get("id") ?? undefined;
  const variant = searchParams.get("variant") ?? undefined;
  const quantity = searchParams.get("quantity") ?? undefined;
  const redirectStatus = searchParams.get("redirect_status") ?? undefined;
  const couponName = searchParams.get("coupon") ?? undefined;

  return {
    chosenPriceId,
    dosage,
    form,
    priceId,
    variant,
    quantity,
    redirectStatus,
    couponName,
  };
};
